import { DataProvider } from 'react-admin'
import simpleRestProvider from 'ra-data-simple-rest'

import { FetcherClient } from 'services/fetcher'
import { convertFileToBase64 } from 'utils/convertFileToBase64'

const removeInvalidFieldsInArray = (data: any) => {
  const result = data

  if (result?.contents) {
    Object.keys(result?.contents).forEach((key) => {
      if (Array.isArray(result?.contents[key])) {
        result.contents[key] = result?.contents[key].filter(
          (item: any) => item && item?.id,
        )
      }
    })
  }

  return result
}

const apiUrl = process.env.REACT_APP_MS_API_BASE_URL || ''

const dataProvider = simpleRestProvider(apiUrl)

const provider: DataProvider = {
  ...dataProvider,
  getOne: async (resource, params) => {
    const { id = '' } = params
    return await FetcherClient(`/${resource}/${id}`, { method: 'GET' }).then(
      (response) => {
        const { resource = {} } = response?.data || []
        return {
          data: {
            ...resource,
          },
          status: response?.status || 0,
        }
      },
    )
  },

  getList: async (resource, params) => {
    return await FetcherClient(`/${resource}`, { method: 'GET', params }).then(
      (response) => {
        return {
          total: +response?.data?.total || 0,
          data: response?.data?.resources || [],
          status: response?.status,
        }
      },
    )
  },

  update: async (resource, params) => {
    // const newParams = {
    //   previousData: params.previousData,
    //   newData: params.data,
    // }

    const canHaveFiles = [
      'cms/content/images',
      'cms/content/attachments',
      'cms/content/users',
      'cms/content/involved_people',
    ];

    if (canHaveFiles.includes(resource) && params?.data?.files) {
      const newImage = await convertFileToBase64(params.data.files)
      params.data.files.src = newImage
    };

    const response = await FetcherClient(`/${resource}/${params.id}`, {
      method: 'PUT',
      data: JSON.stringify(removeInvalidFieldsInArray(params.data)),
    }).then(({ data = {}, status = 0 }) => ({ data, status }))

    return response
  },

  create: async (resource, params): Promise<any> => {
    const canHaveFiles = [
      'cms/content/images',
      'cms/content/attachments',
      'cms/content/users',
      'cms/content/involved_people',
    ]

    if (canHaveFiles.includes(resource) && params?.data?.files) {
      const newImage = await convertFileToBase64(params.data.files)
      params.data.files.src = newImage
    }

    return FetcherClient(`/${resource}`, {
      method: 'POST',
      data: removeInvalidFieldsInArray(params?.data) || [],
    }).then((response) => {
      return {
        data: { id: '', ...response?.data } || [],
      }
    })
  },

  getMany: async (resource, params) => {
    const filter = { filter: params };

    return await FetcherClient(`/${resource}`, { method: 'GET', params: filter }).then(
      (response) => {
        return {
          data: response?.data?.resources || [],
        }
      },
    )
  },

  getManyReference: async (resource, params) => {
    return await FetcherClient(`/${resource}`, { method: 'GET', params }).then(
      (response) => {
        return {
          total: +response?.data?.total || 0,
          data: response?.data?.resources || [],
          status: response?.status,
        }
      },
    )
  }
}

export default provider
